import * as Config from "effect/Config";
import * as Effect from "effect/Effect";
import * as Clank from "../Util/Clank.js";
import { AuthError } from "./AuthProvider.js";
export const getEnv = (key) => Config.string(key).pipe(Effect.orElseSucceed(() => undefined));
export const getEnvRequired = (key) => Config.string(key).pipe(Effect.catch(() => Effect.fail(new AuthError({ message: `Missing required env: ${key}` }))));
export const getEnvRedacted = (key) => Config.redacted(key).pipe(Effect.orElseSucceed(() => undefined));
export const getEnvRedactedRequired = (key) => Config.redacted(key).pipe(Effect.catch(() => Effect.fail(new AuthError({ message: `Missing required env: ${key}` }))));
export const retryOnce = (self) => self.pipe(Effect.retry({
    times: 1,
    while: (e) => e instanceof Clank.PromptCancelled,
}), Effect.mapError((e) => new AuthError({ message: "User cancelled prompt", cause: e })));
//# sourceMappingURL=Env.js.map